module.exports = __webpack_public_path__ + "pic_bizny_web_03-640@2x.png?4ecd79b52509c553a645e62a5094ed6a";